import * as React from "react";

import { ClipboardButton } from "azure-devops-ui/Clipboard";
import { Location } from "azure-devops-ui/Utilities/Position";
import { ObservableValue } from "azure-devops-ui/Core/Observable";
import { Observer } from "azure-devops-ui/Observer";
import { TextField } from "azure-devops-ui/TextField";
import { ITooltipProps } from "azure-devops-ui/TooltipEx";

const ClipboardButtonExample: React.FunctionComponent = (props) => {
    const textFieldValue = new ObservableValue<string>("Text Copy");
    const textFieldLabel = "Enter text to copy to the clipboard.";
    const lastCopied = new ObservableValue<number>(-1);
    const copyToClipboardLabel = "Copy to Clipboard";

    const italicRef = React.createRef<HTMLElement>();
    const boldEx = <b className="flex-row flex-center">JSX.Element Copy: Bold</b>;

    const onChange = (ev: any, value: string) => {
        textFieldValue.value = value;
    };

    const getTooltip = (index: number, lastCopied: number): ITooltipProps => {
        return {
            text: index === lastCopied ? "Copied to clipboard!" : "Click to copy",
            anchorOrigin: {
                horizontal: Location.center,
                vertical: Location.end,
            },
            tooltipOrigin: {
                horizontal: Location.center,
                vertical: Location.start,
            },
        };
    };

    return (
        <div className="flex-column">
            <Observer lastCopied={lastCopied}>
                {(props: { lastCopied: number }) => (
                    <>
                        <div
                            className="flex-row"
                            style={{ margin: "8px", justifyContent: "space-between" }}
                        >
                            <TextField value={textFieldValue} onChange={onChange} ariaLabel={textFieldLabel} />
                            <Observer value={textFieldValue}>
                                {(observerProps: { value: string }) => (
                                    <ClipboardButton
                                        ariaLabel={observerProps.value + " " + copyToClipboardLabel}
                                        getContent={() => {
                                            return textFieldValue.value;
                                        }}
                                        onCopy={() => (lastCopied.value = 1)}
                                        tooltipProps={getTooltip(1, props.lastCopied)}
                                    />
                                )}
                            </Observer>
                        </div>
                        <div
                            className="flex-row"
                            style={{ margin: "8px", justifyContent: "space-between" }}
                        >
                            <i ref={italicRef} className="flex-row flex-center">
                                HTMLElement Copy: Italic
                            </i>
                            <ClipboardButton
                                ariaLabel={"HTMLElement Copy: Italic " + copyToClipboardLabel}
                                getContent={() => {
                                    return italicRef.current!;
                                }}
                                onCopy={() => (lastCopied.value = 2)}
                                tooltipProps={getTooltip(2, props.lastCopied)}
                            />
                        </div>
                        <div
                            className="flex-row"
                            style={{ margin: "8px", justifyContent: "space-between" }}
                        >
                            {boldEx}
                            <ClipboardButton
                                ariaLabel={"JSX.Element Copy: Bold " + copyToClipboardLabel}
                                getContent={() => boldEx}
                                onCopy={() => (lastCopied.value = 3)}
                                tooltipProps={getTooltip(3, props.lastCopied)}
                            />
                        </div>
                    </>
                )}
            </Observer>
        </div>
    );
};

export default ClipboardButtonExample;
